/* eslint-disable  */

export default {
  'Login to view price': 'Cena dostępna u doradcy Extracts.Pro lub po zalogowaniu się',
  'Account': 'Konto',
  'Wishlist': 'Ulubione',
  'Cart': 'Koszyk',
  'Home': 'Start',
  'Menu': 'Menu',
  'Sort: Default': 'Domyślnie',
  'Sort: Name A-Z': 'Nazwa A-Z',
  'Sort: Name Z-A': 'Nazwa Z-A',
  'Sort: Price from high to low': 'Cena od najwyższej do najniższej',
  'Sort: Price from low to high': 'Cena od najniższej do najwyższej',
  'Add new address': 'Dodaj nowy adres',
  'Back to home': 'Wrócić do strony głównej',
  'Billing address': 'Dane do faktury',
  'Create an account': 'Utwórz konto',
  'Discount': 'Rabat',
  'Email address': 'Adres e-mail',
  'Enter promo code': 'Wpisz kod promocyjny',
  'First Name': 'Imię',
  'Forgot Password': 'Jeśli nie pamiętasz hasła, możesz je zresetować.',
  'Forgot Password Modal Email': 'Adres e-mail, którego używasz do logowania:',
  'Forgotten password?': 'Zapomniane hasło?',
  'I want to create an account': 'Chcę założyć konto',
  'Last Name': 'Nazwisko',
  'My Account': 'Moje konto',
  'Login': 'Zaloguj sie',
  'login in to your account': 'zaloguj się na swoje konto',
  'Match it with': 'Dopasuj to do',
  'No account': 'Nie masz jeszcze konta?',
  'or': 'lub',
  'Order summary': 'Podsumowanie zamowienia',
  'Other products you might like': 'Inne produkty, które mogą Ci się spodobać',
  'Password': 'Hasło',
  'Password Changed': 'Hasło zostało pomyślnie zmienione. Możesz teraz wrócić do strony głównej i zalogować się.',
  'Products': 'Produkty',
  'Quantity': 'Ilość',
  'Register': 'Zarejestruj się',
  'Register today': 'Zarejestruj się już dziś',
  'Repeat Password': 'Powtórz hasło',
  'Reset password': 'Zresetuj hasło',
  'Save Password': 'Zapisz hasło',
  'Shipping': 'Wysyłka',
  'Shipping address': 'Adres dostawy',
  'Shipping method': 'Metoda wysyłki',
  'Sign Up for Newsletter': 'Zarejestruj się aby otrzymać newsletter',
  'Subtotal': 'Suma częściowa',
  'Thank You Inbox': 'Jeśli wiadomość nie dotrze do Twojej skrzynki odbiorczej, spróbuj użyć innego adresu e-mail, którego mogłeś użyć do rejestracji.',
  'Total': 'Suma',
  'Vue Storefront Next': 'Vue Storefront Next',
  'Your email': 'Twój email',
  'Invalid email': 'Podaj poprawny adres e-mail',
  'My wishlist': 'Moja lista życzeń',
  'You are not authorized, please log in.': 'Zostałeś wylogowany. Zaloguj się ponownie.',
  'House/Apartment number': 'Numer budynku/mieszkania',
  'Apartment number': 'Numer mieszkania',
  'Building number': 'Numer budynku',
  'Street Name': 'Nazwa ulicy',
  'City': 'Miasto',
  'State/Province': 'Województwo',
  'Zip-code': 'Kod pocztowy',
  'Country': 'Kraj',
  'Phone number': 'Numer telefonu',
  'This field is required': 'To pole jest wymagane',
  'The field should have at least 2 characters': 'Pole powinno zawierać co najmniej 2 znaki',
  'The field should have at least 4 characters': 'Pole powinno zawierać co najmniej 4 znaki',
  'The field should have at least 8 characters': 'Pole powinno zawierać minimum 8 znaków',
  'There are no shipping methods available for this country. We are sorry, please try with different country.': 'Dla tego kraju nie są dostępne żadne metody wysyłki. Przepraszamy, spróbuj wybrać inny kraj.',
  'There was some error while trying to select this shipping method. We are sorry, please try with different shipping method.': 'Wystąpił błąd podczas próby wybrania tej metody wysyłki. Przepraszamy, spróbuj użyć innej metody wysyłki.',
  'We can\'t find products matching the selection.': 'Przepraszamy, nie znaleźliśmy żadnych pasujących produktów.',
  'An error occurred': 'Wystąpił błąd',
  'Yes': 'Tak',
  'No': 'Nie',
  'From': 'Z',
  'To': 'Do',
  'Enter different address': 'Wprowadź inny adres',
  'Add to cart': 'Dodaj do koszyka',
  'Starting at': 'Zaczynając od',
  'Company name': 'Nazwa firmy',
  'Tax identification number': 'NIP',
  'Price': 'Cena',
  'Please provide a valid NIP': 'Proszę podać prawidłowy NIP',
  'The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.': 'Wprowadziłeś błędne dane logowania. Spróbuj ponownie.',
  'Error during reCaptcha verification. Please try again.': 'Błąd podczas weryfikacji reCaptcha. Spróbuj ponownie.',
  'A customer with the same email address already exists in an associated website.': 'Klient o tym samym adresie e-mail już istnieje w powiązanej witrynie.',
  'The requested qty is not available': 'Wybrana ilość nie jest dostępna',
  'Header search placeholder': 'Wpisz czego szukasz...',
  'Contact': 'Kontakt',
  'Online store': 'Sklep internetowy',
  'Articles': 'Artykuły',
  'All categories': 'Wszystkie kategorie',
  'Email or login': 'E-mail lub login',
  'Sign in': 'Zaloguj się',
  'Remember me': 'Zapamiętaj mnie',
  'Forgot your password?': 'Nie pamiętasz hasła?',
  'Or continue with': 'Lub kontynuuj z',
  'Name (required)': 'Imię (wymagane)',
  'Surname (required)': 'Nazwisko (wymagane)',
  'Email (required)': 'E-mail (wymagane)',
  'Password (required)': 'Hasło (wymagane)',
  'Password requirements': 'Hasło musi mieć jedną wielką literę, jedną małą literę, jedną cyfrę, znak specjalny oraz minimum 6 znaków.',
  'Select all': 'Zaznacz wszystko',
  'Enter your email address to receive instructions on how to reset your password.': 'Podaj swój adres e-mail, aby otrzymać instrukcje dotyczące resetowania hasła.',
  'Or back to sign in': 'Lub wróć do logowania',
  'Subscribe': 'Subskrybuj',
  'Sorting': 'Sortowanie',
  'All filters': 'Wszystkie filtry',
  'Go to payment': 'Przejdź do płatności',
  'Go to delivery': 'Przejdź do dostawy',
  'Return to shopping': 'Powrót do zakupów',
  'Buy as guest': 'Kup jako gość',
  'Buy without registration': 'Kup bez rejestracji',
  'Without an account, you will not be able to check your order history, and your data will not be saved.': 'Jeśli się stworzysz konta, nie będziesz miał dostępu do historii zamówień, a Twoje dane nie zostaną zapisane.',
  'Address (street -> street number -> city)': 'Adres (ulica -> numer ulicy -> miasto)',
  'Additional information': 'Dodatkowe informacje',
  'Formal approvals': 'Zgody formalne',
  'Return to cart': 'Wróć do koszyka',
  'Delivery Method:': 'Sposób dostawy:',
  'Select delivery method': 'Wybierz sposób dostawy',
  'Payment Method:': 'Sposób płatności:',
  'Select payment method': 'Wybierz sposób płatności',
  'Select': "Wybierz",
  'Do you have a discount code?': 'Posiadasz kod rabatowy?',
  'Add': 'Dodaj',
  'Remove': 'Usuń',
  'Cancel': 'Anuluj',
  'Cart value': 'Wartość koszyka',
  'Total to be paid': 'Łącznie do zapłaty',
  'Go to summary': 'Przejdź do podsumowania',
  'Private individual (receipt)': 'Osoba prywatna (paragon)',
  'Company (VAT invoice)': 'Firma (faktura VAT)',
  'I want to add a comment to the order': 'Chcę dodać komentarz do zamówienia',
  'Enter your comments here': 'Wpisz tutaj Twoje uwagi',
  'Delivery': 'Dostawa',
  'You are buying as': 'Kupujesz jako',
  'Payment': 'Płatność',
  'Return to delivery and payment': 'Wróć do dostawy i płatności',
  'Buy and pay': 'Kupuję i płacę',
  'Clear the cart': 'Wyczyść koszyk',
  'Message text': 'Tekst wiadomości',
  'Find content that interests you': 'Znajdź interesujące Cię treści',
  'I want to change my password': 'Chcę zmienić hasło',
  'Current password': 'Obecne hasło',
  'New password': 'Nowe hasło',
  'Access to location is blocked': 'Dostęp do lokalizacji jest zablokowany',
  'An error occurred while submitting the form': 'Wystąpił błąd podczas wysyłania formularza',
  'The message has been sent': 'Wiadomość została wysłana',
  'Newsletter signup error': 'Błąd zapisu na newsletter',
  'Subscribed to the newsletter': 'Zapisano na newsletter',
  'Saving alert error. Try again': 'Wystąpił błąd podczas zapisywania alertu. Spróbuj ponownie.',
  'The alert subscription has been saved': 'Subskrypcja alertu została zapisana.',
  'The product has been added to your cart!': 'Produkt został dodany do koszyka!',
  'Successfully updated the quantity of product x in the shopping cart': 'Pomyślnie zaktualizowano ilość produktu {x} w koszyku',
  'Unable to update product x: The selected quantity is not available': 'Nie można zaktualizować produktu {x}: Wybrana ilość nie jest dostępna',
  'x was successfully removed from the basket': '{x} został pomyślnie usunięty z koszyka',
  "x was successfully removed from the quote": "{x} został pomyślnie usunięty z zapytania",
  'All products have been successfully removed from the shopping cart.': 'Wszystkie produkty zostały pomyślnie usunięte z koszyka.',
  'Registered successfully': 'Zarejestrowano pomyślnie',
  'Registered successfully. Your account is awaiting confirmation.': 'Zarejestrowano pomyślnie. Twoje konto oczekuje na potwierdzenie.',
  'We have retained the products saved in your account.': 'Zachowaliśmy produkty zapisane w Twoim koncie.',
  'Failed to log in': 'Nie udało się zalogować',
  'Confirm your account and check email': 'Musisz potwierdzić swoje konto. Sprawdź, czy w skrzynce e-mail znajduje się link potwierdzający.',
  'Logged in successfully': 'Zalogowano pomyślnie',
  'Successfully changed the password': 'Hasło zostało pomyślnie zmienione',
  'The link has expired. Try again.': 'Link wygasł. Spróbuj ponownie.',
  'An error occurred while disconnecting the social account': 'Wystąpił błąd podczas rozłączania konta społecznościowego',
  'An error occurred while connecting a social account': 'Wystąpił błąd podczas łączenia konta społecznościowego',
  'Your user account information has been successfully updated': 'Dane użytkownika zostały pomyślnie zaktualizowane!',
  'You removed x from your wish list.': 'Usunąłeś {x} z listy życzeń.',
  'You must be logged in to add this product to your wish list': 'Musisz być zalogowany, aby dodać ten produkt do listy życzeń!',
  'You have added x to your wish list.': 'Dodałeś {x} do swojej listy życzeń.',
  'Cleared wish lists.': 'Wyczyszczono listę życzeń.',
  'You have added x to your cart.': 'Dodałeś {x} do koszyka.',
  'There is no company in the GUS database with the given tax identification number': 'W bazie danych GUS nie ma spółki o podanym numerze identyfikacji podatkowej',
  'GUS database is temporarily unavailable, please enter data manually': 'Baza GUS jest chwilowo niedostępna, proszę wprowadzić dane ręcznie',
  'Your account was successfully unlinked.': 'Twoje konto zostało pomyślnie odłączone.',
  'The field should have at least {length} characters': 'Pole powinno zawierać co najmniej {length} znaków',
  'Invalid password message': 'Hasło musi mieć jedną wielką literę, jedną małą literę, jedną cyfrę, znak specjalny oraz minimum 6 znaków.',
  'Passwords don\'t match': 'Hasła nie pasują do siebie',
  'Incorrect e-mail address': 'Nieprawidłowy adres e-mail',
  'Please provide a valid phone number': 'Podaj poprawny numer telefonu',
  'Please provide a valid NIP': 'Podaj poprawny NIP',
  'Invalid country': 'Nieprawidłowy kraj',
  'An error occurred while loading the page': 'Wystąpił błąd podczas ładowania strony',
  'Try again or go back to the home page': 'Spróbuj ponownie lub wróć na stronę główną',
  'Back to home page': 'Wróć na stronę główną',
  'We looked everywhere': 'Szukaliśmy wszędzie...',
  'but it seems that the specified site does not exist': 'ale wygląda na to, że podana strona nie istnieje',
  'Do you have a question?': 'Masz pytanie?',
  'Get in touch with us!': 'Skontaktuj się z nami!',
  'Online store hotline': 'Infolinia sklepu internetowego',
  'Shipping methods': 'Metody wysyłki',
  'Safe shopping': 'Bezpieczne zakupy',
  'Information': 'Informacje',
  'Customer zone': 'Strefa klienta',
  'Return to store': 'Wróć do sklepu',
  'brand zone': 'Strefa Marek',
  'Choose products from numerous brands': 'Wybieraj produkty spośród licznych marek',
  'Meet the Best Manufacturers': 'Poznaj najlepszych Producentów',
  'show more': 'pokaż więcej',
  'show less': 'pokaż mniej',
  'See all brands': 'Zobacz wszystkie marki',
  'Find the right products for your crop': 'Znajdź odpowiednie produkty dla swojego uprawy',
  'crop': 'uprawa',
  'See more crops': 'Zobacz więcej upraw',
  'Find the best fertilizer for your crop': 'Znajdź najlepszy nawóz dla swojej uprawy',
  'See all fertilizers': 'Zobacz wszystkie nawozy',
  'fertilizer': 'nawóz',
  'Looking for': 'Szukasz',
  'New Products': 'Nowości',
  'Plant protection products': 'Środki ochrony roślin',
  'Fertilizers': 'Nawozy',
  'Tools and accessories': 'Narzędzia i akcesoria',
  'Home and garden': 'Dom i ogród',
  'See all': 'Zobacz wszystkie',
  'Promotions': 'Promocje',
  'Recommended by Advisors': 'Polecane przez Doradców',
  'FVAT only': 'tylko FVAT',
  'bestseller': 'bestseller',
  'recommended': 'Polecane',
  'novelty': 'nowość',
  'News': 'Aktualności',
  'Sign up and stay up to date!': 'Zapisz się na newsletter i bądź na bieżąco!',
  'Leave us your email address and receive reliable information': 'Otrzymuj najnowsze wiadomości i informacje',
  'Sign up newsletter rules': 'Zgadzam się na otrzymywanie drogą elektroniczną na podany adres email informacji handlowych dotyczących ciekawych produktów i usług {x} oraz jej Partnerów.',
  'product available': 'produkt dostępny',
  'available on order': 'dostępny na zamówienie',
  'withdrawn from sale': 'wycofany ze sprzedaży',
  'temporarily unavailable': 'tymczasowo niedostępny',
  'shipping in': 'wysyłka w ',
  'Shipping within': 'Wysyłka w ciągu',
  'A summary of the order and progress information will be sent to the email address provided.': 'Podsumowanie zamówienia i informacje o postępach zostaną wysłane na podany adres e-mail.',
  'Continue reading': 'Przeczytaj więcej',
  'recommendations': 'rekomendacje',
  'Get to know the opinions of our customers': 'Poznaj opinie naszych klientów',
  'About us': 'O nas',
  'Store addresses': 'Adresy sklepów',
  'Sales representatives': 'Przedstawiciele handlowi',
  'Weather forecast': 'Prognoza pogody',
  'Career': 'Kariera',
  'RODO Contact': 'Kontakt RODO',
  'Security': 'Bezpieczeństwo',
  'Tax strategy': 'Strategia podatkowa',
  'Payments': 'Płatności',
  'Shipping and delivery': 'Wysyłka i dostawa',
  'Returns & complaints': 'Zwroty i reklamacje',
  'Questions and answers': 'Pytania i odpowiedzi',
  'Terms and conditions of shopping': 'Regulamin zakupów',
  'Privacy policy': 'Polityka prywatności',
  'See more': 'Zobacz więcej',
  'See less': 'Zobacz mniej',
  'See also': 'Zobacz także',
  'Check': 'Sprawdź',
  'Logging': 'Logowanie',
  'Registration': 'Rejestracja',
  'B2B Registration': 'Rejestracja B2B',
  'Log in via x': 'Zaloguj się przez {x}',
  'Back to home page': 'Wróć do strony głównej',
  'Hotline': 'Infolinia',
  'The administrator of the personal data you provided in the form is x': 'Administratorem podanych przez Ciebie w formularzu danych osobowych jest {x}',
  'Learn more': 'Dowiedz się więcej',
  'Back': 'Wróć',
  'I agree to receive marketing information from x': 'Wyrażam zgodę na otrzymywanie od {x} informacji marketingowych, w tym o najnowszych promocjach, ofertach i usługach dodatkowych za pomocą telekomunikacyjnych urządzeń końcowych, tj. mojego numeru telefonu (połączenia głosowe).',
  'I accept': 'Akceptuję',
  'Regulations': 'Regulamin',
  'and': 'i',
  'Privacy policy 2': 'Politykę prywatności',
  'Delivery starting at': 'Dostawa już od',
  'Secure': 'Bezpieczne',
  'online shopping': 'zakupy online',
  'Only': 'Tylko',
  'original products': 'oryginalne produkty',
  'polish company': 'polska firma',
  'Product available only': 'Produkt dostępny wyłącznie',
  'with FVAT': 'z FVAT',
  'by phone': 'telefonicznie',
  'Product variant': 'Wariant produktu',
  'Choose a variant': 'Wybierz wariant',
  'Number': 'Liczba',
  'View price history': 'Zobacz historię ceny',
  'To cart': 'Do koszyka',
  'or order by phone': 'lub zamów telefonicznie',
  'Customers also viewed': 'Klienci oglądali również',
  'Return to shopping': 'Wróć do zakupów',
  'We invite you to shop!': 'Zapraszamy do zakupów!',
  'Your cart is empty': 'Twój koszyk jest pusty',
  'Check more': 'Sprawdź więcej',
  'Hello': 'Witaj',
  'My data': 'Moje dane',
  'Order history': 'Historia zakupów',
  'My addresses': 'Moje adresy',
  'Favorites': 'Ulubione',
  'Merging accounts': 'Łączenie kont',
  'Log out': 'Wyloguj się',
  'Edit account details': 'Edytuj dane konta',
  'Save changes': 'Zapisz zmiany',
  'My orders': 'Moje zamówienia',
  'You currently have no orders': 'Obecnie nie masz żadnych zamówień',
  'Start shopping': 'Rozpocznij zakupy',
  'Show on page': 'Pokaż na stronie',
  'Address book': 'Książka adresowa',
  'Add an address': 'Dodaj nowy adres',
  'Wish list is empty': 'Lista życzeń jest pusta',
  'It looks like you have not added any items to your wish list.': 'Wygląda na to, że nie dodałeś żadnych elementów do listy życzeń.',
  'Connect or disconnect from accounts': 'Połącz lub rozłącz się z kontami',
  'Disconnect from': 'Rozłącz z ',
  'Connect with': 'Połącz z ',
  'Save address': 'Zapisz adres',
  'Eco certificate': 'Certyfikat eko',
  'Kit components': 'Składniki zestawu',
  'Product description and specifications': 'Opis produktu i specyfikacja',
  'Downloads': 'Pliki do pobrania',
  'User reviews': 'Opinie użytkowników',
  'Often bought together': 'Często kupowane razem',
  'In the same category': 'W tej samej kategorii',
  'You may need': 'Możesz potrzebować',
  'The product has many options': 'Produkt ma wiele opcji',
  'Instructions for resetting your password have been sent': 'Instrukcja dotycząca resetowania hasła została wysłana na Twój adres e-mail. Sprawdź skrzynkę odbiorczą.',
  'Back to login': 'Powrót do logowania',
  'Manufacturers in x from A to Z': 'Producenci w {x} od A do Z',
  'We present the most popular brands available in x': 'Prezentujemy najpopularniejsze marki dostępne w {x}',
  'You are saving': 'Oszczędzasz',
  'Adding products to the shopping cart does not mean reserving them. Finish placing your order.': 'Dodanie produktów do koszyka nie oznacza ich rezerwacji. Dokończ składanie zamówienia.',
  'Buy at': 'Kupuj w',
  'Trusted store': 'Zaufanym sklepie',
  'In total': 'Łącznie',
  'Category': 'Kategoria',
  'Use my location': 'Użyj mojej lokalizacji',
  'Lowest price in the last 30 days': 'Najniższa cena w ostatnich 30 dniach',
  'Remove from wishlist': 'Usuń z listy życzeń',
  'Add to wishlist': 'Dodaj do listy życzeń',
  'Download PDF': 'Pobierz PDF',
  'No articles': 'Brak artykułów',
  'Select a department': 'Wybierz dział',
  'Enter the topic of conversation': 'Wpisz temat rozmowy',
  'Message': 'Wiadomość',
  'Send': 'Wyślij',
  'Contact form submission information': 'Administratorem Państwa danych osobowych jest {x}. Państwa dane osobowe będą przetwarzane w celu odpowiedzi na zadane pytanie oraz archiwizacji formularza. Więcej informacji na temat przetwarzania Państwa danych osobowych znajduje się w Polityce prywatności.',
  'Expand text': 'Rozwiń tekst',
  'Collapse text': 'Zwiń tekst',
  'No description': 'Brak opisu',
  'newsletter': 'Newsletter',
  'promotion': 'promocja',
  'promotion short': 'promo',
  'Check out the offer': 'Sprawdź ofertę',
  'Opening hours': 'Godziny otwarcia',
  'Lead to the store': 'Prowadź do sklepu',
  'View store': 'Zobacz sklep',
  'Homepage': 'Strona główna',
  'Active code': 'Aktywny kod',
  'cheaper as much as': 'taniej aż',
  'Call and place your order': 'Zadzwoń i złóż zamówienie',
  'Contact on business days from x to y': 'Kontakt w dni robocze od {x} do {y}',
  'tel.': 'tel.',
  'Default delivery address': 'Domyślny adres dostawy',
  'Default billing address': 'Domyślny adres rozliczeniowy',
  'Want to see the weather forecast for this location?': 'Chcesz zobaczyć prognozę pogody dla tej lokalizacji?',
  'Poland': 'Polska',
  'Width': 'Szerokość',
  'Height': 'Wysokość',
  'Length': 'Długość',
  'Approve': 'Zatwierdź',
  'Payment card': 'Karta płatnicza',
  'Quick online transfer': 'Szybki przelew internetowy',
  'Pay later': 'Płacę później',
  'Google Pay': 'Google Pay',
  'Apple pay': 'Apple Pay',
  'The least you can purchase is x.': 'Najmniej, ile możesz zakupić to {x}.',
  'The most you can purchase is x.': 'Najwięcej, ile możesz zakupić to {x}.',
  'You can only buy this product in quantities of x at a time.': 'Możesz kupić ten produkt tylko w ilościach {x} na raz.',
  'Active filters': 'Aktywne filtry',
  'Clear filters': 'Wyczyść filtry',
  'Product categories': 'Kategorie produktów',
  'All products': 'Wszystkie produkty',
  'Filtering': 'Filtrowanie',
  'Show results': 'Pokaż wyniki',
  'Save for later': 'Zapisz na później',
  'Popular in this category': 'Popularne w tej kategorii',
  'Select a variant to add the product to your cart': 'Wybierz wariant, aby dodać produkt do koszyka',
  'cheaper together': 'razem taniej',
  'Crop group': 'Grupa upraw',
  'Fertilizer composition': 'Skład nawozu',
  'Notify availability': 'Powiadom o dostępności',
  'Thank you for subscribing': 'Dziękuję za subskrypcję',
  'You will receive an email as soon as the selected product goes on sale.': 'Dostaniesz maila, jak tylko wybrany produkt pojawi się w sprzedaży.',
  'Availability notice': 'Powiadomienie o dostępności',
  'To notify you of availability, you must be': 'Aby powiadomić Cię o dostępności, musisz być',
  'logged in': 'zalogowany',
  'From 2': 'Od',
  'Product delivery text 1': 'Koszt dostawy zamówień za pobraniem powiększony jest o dodatkową opłątę 5 zł. Koszty dostawy wyliczane są w koszyku na podstawie wagi i gabarytów zamówienia. Przy zakupie większej ilości towaru produkty mogą zostać wysłane na palecie EUR 120x80cm',
  'Product delivery text 2': 'Przy zakupie większej ilości towarów wykraczających poza jedną paletę skontaktujemy się z Tobą w celu ustalenia warunków dostawy. (Warunki naliczane są indywidualnie w zależności od odległości i wagi zamówionych towarów)',
  'Courier': 'Kurier',
  'parcel machine': 'paczkomat',
  'Polish Post': 'Poczta Polska',
  'Payment methods': 'Metody płatności',
  'The lowest price from 30 days before the reduction': 'Najniższa cena z 30 dni przed obniżką',
  'Buy as a set': 'Kup w zestawie',
  'Add for': 'Dodaj za',
  'pcs.': 'szt.',
  'Price for you': 'Cena dla Ciebie',
  'buy at price': 'kup w cenie',
  'I want to provide other invoice details': 'Chcę podać inne dane do faktury',
  'Delete downloaded data': 'Usuń pobrane dane',
  'Download data from GUS': 'Pobierz dane z GUS',
  'Edit': 'Edytuj',
  'Don\'t see your address? Click here and add it manually': 'Nie widzisz swojego adresu? Kliknij tutaj i dodaj go ręcznie',
  'Change': 'Zmień',
  'Select a point': 'Wybierz punkt',
  'Your browser does not support iframes': 'Twoja przeglądarka nie obsługuje iframe',
  'There are products in your shopping cart': 'W koszyku znajdują się produkty',
  'available for VAT invoice only, company details will be required to finalize the order.': 'dostępny tylko na fakturę VAT, do finalizacji zamówienia wymagane będą dane firmy.',
  'Order number': 'Zamówienie numer',
  'Thank you': 'Dziękujemy',
  'Are you sure you want to remove this product from your cart?': 'Czy na pewno chcesz usunąć ten produkt z koszyka?',
  'Login or registration': 'Logowanie lub rejestracja',
  'Delivery and payment': 'Dostawa i płatność',
  'Summary': 'Podsumowanie',
  'Finished': 'Gotowe',
  'Payment on delivery': 'Płatność przy odbiorze',
  'Fill in the mandatory fields': 'Wypełnij pola obowiązkowe',
  'Pickup Point Address': 'Adres punktu odbioru',
  'Enter the 6-digit code obtained from your banking application': 'Podaj 6-cyfrowy kod uzyskany ze swojej aplikacji bankowej',
  'Company': 'Firma',
  'Private individual': 'Osoba prywatna',
  'Congratulations, we have received your order!': 'Gratulacje, otrzymaliśmy Twoje zamówienie!',
  'Payment details': 'Dane do płatności',
  'Please make your payment to the bank account': 'Prosimy o wpłatę na konto bankowe',
  'Title': 'Tytuł',
  'Title 2': 'Tytułem',
  'order': 'zamówienie',
  'Once the payment is credited, we will forward the order for processing.': 'Po zaksięgowaniu wpłaty przekażemy zamówienie do realizacji.',
  'Your order': 'Twoje zamówienie',
  'By logging in, we will assign the placed order to your user account.': 'Zaloguj się, abyśmy mogli powiązać Twoje zamówienie z kontem użytkownika.',
  'Update address': 'Zaktualizuj adres',
  'Set as default delivery address': 'Ustaw jako domyślny adres dostawy',
  'Set as default billing address': 'Ustaw jako domyślny adres rozliczeniowy',
  'To change your email address, enter your current password.': 'Aby zmienić adres e-mail, wpisz swoje aktualne hasło.',
  'My order': 'Moje zamówienie',
  'Back to list': 'Wróć do listy',
  'Product': 'Produkt',
  'Order ID': 'ID zamówienia',
  'Date': 'Data',
  'Status': 'Status',
  'Order details': 'Szczegóły zamówienia',
  'Billing address 2': 'Adres rozliczeniowy',
  'Payment method': 'Metoda płatności',
  'Payment date': 'Data płatności',
  'Amount': 'Kwota',
  'Blog categories': 'Kategorie bloga',
  'Read also': 'Przeczytaj także',
  'All entries': 'Wszystkie wpisy',
  'open category list': 'otwórz listę kategorii',
  'Leader in agricultural and horticultural supplies will hire for the position of': 'Lider w zaopatrzeniu rolnictwa i ogrodnictwa zatrudni na stanowisko',
  'Hours dimension': 'Wymiar godzin',
  'Experience': 'Doświadczenie',
  'Form of employment': 'Forma zatrudnienia',
  'Work mode': 'Tryb pracy',
  'Choose': 'Wybierz',
  'promotional product': 'produkt promocyjny',
  'for your order': 'do Twojego zamówienia',
  'We accept payments': 'Akceptujemy płatności',
  'You may need also': 'Możesz potrzebować także',
  'Distribution': 'Dystrybucja',
  'Wholesale': 'Sprzedaż hurtowa',
  'Retail': 'Sprzedaż detaliczna',
  'Cooperation type': 'Rodzaj współpracy',
  'Sales channel': 'Kanał sprzedaży',
  'Online': 'Online',
  'Stationary store': 'Sklep stacjonarny',
  'Marketplace': 'Marketplace',
  'Trade fair': 'Targi',
  'Other': 'Inne',
  'Please select at least one sales channel': 'Wybierz przynajmniej jeden kanał sprzedaży',
  'Fast registration': 'Szybka rejestracja',
  'Show': 'Pokaż',
  'Hide': 'Ukryj',
  'Get in touch': 'Skontaktuj się',
  'Job offers': 'Oferty pracy',
  'Certifications and contract manufacturing': 'Certyfikaty i produkcja kontraktowa',
  'Personal data and cookies': 'Dane osobowe i cookies',
  'Buy safely': 'Kupuj bezpiecznie',
  'We deliver': 'Dostarczamy',
  'Products of plant origin': 'Produkty pochodzenia roślinnego',
  'GMO-free products': 'Produkty wolne od GMO',
  'Guarantee of the highest quality': 'Gwarancja najwyższej jakości',
  '35 years in the herbal industry': '35 lat w branży zielarskiej',
  'Deployment and application zone': 'Strefa wdrożeń i aplikacji',
  'Advisors': 'Doradcy',
  'Extracts.pro zone': 'Strefa Extracts.pro',
  'Projects and Tenders': 'Projekty i przetargi',
  'Biostimulators': 'Biostymulatory',
  'Liquid and powdery fertilizers': 'Nawozy Płynne i Sypkie',
  'Research & Analysis': 'Badania i Analizy',
  'Seeds and Treatments': 'Nasiona i Zaprawianie',
  'For sports animals': 'Dla zwierząt sportowych',
  'Filters': 'Filtry',
  'Sort by': 'Sortuj WG',
  'Blog search placeholder': 'Znajdź interesujące Cię treści',
  'Company email': 'E-mail firmy',
  'Invoice email': 'E-mail do faktury',
  'Request a quote': 'Zapytaj o ofertę',
  'Clear quote': 'Wyczyść ofertę',
  'Send quote': 'Wyślij ofertę',
  'Are you sure you want to remove this product from your quote?': 'Czy na pewno chcesz usunąć ten produkt z oferty?',
  'Your quote is empty': 'Twój koszyk negocjacyjny jest pusty',
  'Remarks': 'Uwagi',
  'Successfully updated product in the quote': 'Pomyślnie zaktualizowano produkt w ofercie',
  'Unable to update product in the quote': 'Nie można zaktualizować produktu w ofercie',
  'Quote was successfully submitted': 'Oferta została pomyślnie złożona',
  'Unable to submit the quote': 'Nie udało się złożyć oferty',
  'Enter your data': 'Wpisz swoje dane',
  'The product has been added to the offer': 'Produkt został dodany do oferty',
  'Unable to add product to the quote': 'Nie udało się dodać produktu do oferty',
  'Product Type x not supported in add to cart yet': 'Typ produktu {x} nie może być jeszcze dodany do koszyka',
  'Your price proposal has been sent!': 'Twoja propozycja ceny została wysłana!',
  'We have received your price proposal description': 'Otrzymaliśmy Twoją propozycję ceny i skontaktujemy się z Tobą, gdy zostanie rozpatrzona.  Potwierdzenie zgłoszenia oraz link do śledzenia postępów zostały wysłane na Twój adres e-mail. Poniżej znajdziesz szczegóły swojej oferty.',
  'Offer number': 'Numer oferty',
  'Date of offer submission': 'Data złożenia oferty',
  'Unable to create a new quote cart': 'Nie można utworzyć nowego koszyka ofertowego',
  'Unable to move items to the quote cart': 'Nie można przenieść przedmiotów do koszyka ofertowego',
  'Quote cart has been created': 'Koszyk ofertowy został utworzony',
  'Negotiate': 'Negocjuj',
  'Min price to negotiate x': 'Zamów produkty za co najmniej {x} zł, a aktywujesz funkcję negocjacji ceny.',
  'Suggest price': 'Zaproponuj cenę',
  'Suggest price/pc.': 'Zaproponuj cenę/szt.',
  'Suggest your price': 'Zaproponuj swoją cenę',
  'Unit price': 'Cena jednostkowa',
  'Total price': 'Cena całkowita',
  'My offers': 'Moje oferty',
  'To see the products in the negotiation cart': 'Aby zobaczyć produkty w koszyku negocjacyjnym',
  'Add products to your shopping cart to start negotiating': 'Dodaj produkty do koszyka, aby rozpocząć negocjacje',
  'Discover our products': 'Odkryj nasze produkty',
  'Order products for': 'Zamów produkty za',
  'at least x': 'co najmniej {x}',
  'and you will activate the price negotiation function': 'a aktywujesz funkcję negocjacji ceny',
  'negotiated offers': 'Negocjowane oferty',
  'Created': 'Utworzony',
  'Pending': 'Oczekujący',
  'Approved': 'Zatwierdzony',
  'Complete': 'Zakończony',
  'Canceled': 'Anulowany',
  'Expired': 'Wygasły',
  'Holded': 'Wstrzymany',
  'Admin New': 'Admin Nowy',
  'Admin Created': 'Admin Utworzony',
  'offer no.': 'Nr. oferty',
  'date of submission': 'Data złożenia',
  'suggested price': 'Zaproponowana cena',
  'See details': 'Zobacz szczegóły',
  'Buy': 'Kup',
  'Managing cookie settings':'Zarządzanie ustawieniami cookies',
  // used in order history statuses
  'processing': 'W trakcie realizacji',
  'pending_payment': 'Oczekuje na płatność',
  'holded': 'Oczekuje na przelew',
  'open': 'Open',
  'pending': 'Oczekujące',
  'confirmed': 'Potwierdzone',
  'shipped': 'Zamówienie wysłane',
  'complete': 'Zamówienie zrealizowane',
  'canceled': 'Zamówienie anulowane',
  'closed': 'Zamówienie dostarczone',
  'Share': 'Udostępnij',
  'Read more': 'Więcej',
  'Newsletter short consent': 'Wyrażam zgodę na otrzymywanie biuletynów Indena drogą elektroniczną. Aby uzyskać więcej informacji, zapoznaj się z Polityką prywatności',
  'Expiration date': 'Termin ważności',
  'ERROR_VALUE_INVALID - OPENPAYU_PAYMENT_CREATE_AMOUNT_HIGHER_THAN_MAX': 'Kwota zamówienia jest wyższa niż maksymalna wartość dla danej metody płatności',
  'Caregiver profile': 'Profil opiekuna',
  // Delivery methods
  'Delivery 24h': 'Dostawa w 24h',
  'Delivery 72h': 'Dostawa w 72h',
  'Delivery 5d': 'Dostawa w 5 dni',
  'Delivery 14d': 'Dostawa w 14 dni',
  'Delivery 30d': 'Dostawa do 30 dni',
  'Delivery 90d': 'Dostawa do 90 dni',
  'Delivery to order': 'Na zamowienie',
  // PDP
  'Stress factors': 'Czynniki stresowe',
  'Plant condition': 'Kondycja rośliny',
  'Active substance': 'Substancja czynna',
  'Purpose': 'Przeznaczenie',
  'Benefits of use': 'Korzysci',
  "Check details": "Sprawdź szczegóły",
  "Crop regeneration": "Regeneracja upraw",
  "Crop activation": "Aktywacja upraw",
  "Yield and quality building": "Budowanie plonu i jakości",
  "Increasing crop resistance": "Zwiększenie odporności upraw",
  "Composition": "Skład",
  "Original products": "Oryginalne produkty",
  "Negotiating the price pdp": "Złóż zamówienie o wartości min. 10 000 zł, a możliwość negocjacji ceny automatycznie się odblokuje. Sprawdź szczegóły w podsumowaniu koszyka przed finalizacją zamówienia.",
  "Packaging form": "Forma pakowania",
  "Transport form" : "Forma transportu",
  "Follow us on Instagram": "Śledź nas na Instagramie",
  "Free delivery message": "Zostało {amount} do darmowej dostawy",
  "Free delivery message success": "Darmowa dostawa",
  "Wholesale Product Packaging": "Pakowanie hurtowe produktu",

  // coupon error messages
  "A coupon is already applied to the cart. Please remove it to apply another": "Kupon jest już zastosowany. Usuń go, aby zastosować inny",
  "The coupon code isn\'t valid. Verify the code and try again.": "Kod kuponu jest nieprawidłowy. Sprawdź kod i spróbuj ponownie.",

  "Not available": "Niedostępny",
  "Available items were added to the cart": "Dostępne produkty zostały dodane do koszyka",
  "Duplicate order": "Powiel zamówienie",
  "Continue shopping": "Kontynuuj zakupy",

  "Adding to the cart is disabled": "Dodawanie do koszyka jest wyłączone",

  // netto
  "Net price from": "Cena netto od",
  "Net price": "Cena netto",
};
